import React from "react";
import styled from "styled-components";
import Hero from "components/pages/index/Hero";
import About from "components/pages/index/About";
import Stories from "components/pages/index/Stories";
import { FooterWithState } from "components/Footer";
import withApollo from "components/higher-order/withApollo";
import PageContainer from "components/containers/PageContainer";
import { JustSignedUpListener } from "components/listeners/JustSignedUpListener";
import { JustGaveGiftListener } from "components/listeners/JustGaveGiftListener";
import { NewsletterPopupForm } from "components/pages/index/NewsletterPopup";
import { isNil } from "lodash";
import { parseCookies } from "nookies";
import uuidv4 from "uuid/v4";
import { useHomepageState } from "components/optimized/Homepage/Homepage.hooks";

const browserIdCookieName = "juggernautBrowserId";

export const IndexPageContainer = styled.div.attrs({
  className: "w-screen flex flex-col items-center justify-center",
})`
  min-height: calc(100vh - 64px);
`;

const IndexPage = ({ browserId }) => {
  
  const { userIsLoggedIn, shouldHideHero, showPopup } = useHomepageState()

  return (
    <PageContainer>
      <JustSignedUpListener />
      <JustGaveGiftListener />
      <IndexPageContainer>
        {!userIsLoggedIn && !shouldHideHero && (
          <>
            <Hero />
            <About />
          </>
        )}
        <Stories />
      </IndexPageContainer>
      <FooterWithState />
      {showPopup ? <NewsletterPopupForm /> : <></>}
    </PageContainer>
  );
};

IndexPage.getInitialProps = (ctx) => {
  const cookies = parseCookies(ctx);
  let browserId = cookies[browserIdCookieName];

  if (browserId === "undefined" || isNil(browserId)) {
    browserId = uuidv4();
  }

  return {
    browserId,
  };
};

export default IndexPage
